import { render, staticRenderFns } from "./ExportOrders.vue?vue&type=template&id=6b827e14&scoped=true&"
import script from "./ExportOrders.vue?vue&type=script&lang=js&"
export * from "./ExportOrders.vue?vue&type=script&lang=js&"
import style0 from "./ExportOrders.vue?vue&type=style&index=0&id=6b827e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b827e14",
  null
  
)

export default component.exports